// utils/tailwind.ts
// utils / tailwind.ts
import { ColorGroup, isValidColorName, isValidColorVariant, theme } from './theme';

/**
 * Gets the appropriate background color Tailwind class for the given color and variant
 */
export const getColorClass = (colorName: string, variant: string = 'DEFAULT'): string => {
    if (isValidColorName(colorName) && isValidColorVariant(variant)) {
        const colorGroup = theme.colors[colorName];
        
        // Handle the gray scale which uses numeric keys
        if (colorName === 'gray' && !isNaN(Number(variant))) {
            return `bg-gray-${variant}`;
        }
        
        // Handle regular color groups with DEFAULT/dark/light variants
        if (typeof colorGroup === 'object' && colorGroup !== null && !(colorGroup instanceof Array)) {
            if ('DEFAULT' in colorGroup) {
                // It is a ColorGroup
                const color = (colorGroup as ColorGroup)[variant as keyof ColorGroup];
                if (!color) return '';
                
                // If variant is DEFAULT, return bg-{colorName}
                if (variant === 'DEFAULT') {
                    return `bg-${colorName}`;
                }
                
                // Otherwise return bg-{colorName}-{variant}
                return `bg-${colorName}-${variant}`;
            }
        }
    }
    return ''; 
};

/**
 * Gets the appropriate text color Tailwind class for the given color and variant
 */
export const getTextColorClass = (colorName: string, variant: string = 'DEFAULT'): string => {
    if (isValidColorName(colorName) && isValidColorVariant(variant)) {
        const colorGroup = theme.colors[colorName];
        
        // Handle the gray scale which uses numeric keys
        if (colorName === 'gray' && !isNaN(Number(variant))) {
            return `text-gray-${variant}`;
        }
        
        // Handle regular color groups with DEFAULT/dark/light variants
        if (typeof colorGroup === 'object' && colorGroup !== null && !(colorGroup instanceof Array)) {
            if ('DEFAULT' in colorGroup) {
                // It is a ColorGroup
                const color = (colorGroup as ColorGroup)[variant as keyof ColorGroup];
                if (!color) return '';
                
                // If variant is DEFAULT, return text-{colorName}
                if (variant === 'DEFAULT') {
                    return `text-${colorName}`;
                }
                
                // Otherwise return text-{colorName}-{variant}
                return `text-${colorName}-${variant}`;
            }
        }
    }
    return '';
};